import React from 'react';
import PropTypes from 'prop-types';
import { useLabels, usePrefs, useSitemap } from 'wsm-common-data';

import VehicleCard from './VehicleCard';

const VehicleCards = ({
	handleLinkClick,
	searchTerm,
	vehicles,
	inputWidth
}) => {
	const labels = useLabels();
	const { overrideAllInventoryAlias, showVehicleCards, vehicleCardImage } =
		usePrefs();

	const sitemap = useSitemap();
	const FOUR_ZERO_FOUR_PAGE_ALIAS = '404';
	const pageNotFoundPath = sitemap.get(FOUR_ZERO_FOUR_PAGE_ALIAS);
	const allInventoryPath =
		(overrideAllInventoryAlias
			? sitemap.get(overrideAllInventoryAlias)
			: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_ALL')) ||
		pageNotFoundPath;

	const viewLinkLabel = labels.get('VIEW_ALL_VEHICLES_SITE_SEARCH');
	const handleClick = () => {
		handleLinkClick('allInventoryLink', viewLinkLabel, '', '');
	};

	const singleColumnWidth = 600;
	const isDoubleColumn = inputWidth > singleColumnWidth;

	if (showVehicleCards === 'true' && vehicles?.length > 0) {
		let keyCount = 0;
		return (
			<div
				data-testid="modern-vehicle-cards"
				role="region"
				aria-labelledby="vehicle-cards-heading"
				className={`${isDoubleColumn ? '' : 'pb-5'}`}
			>
				<a
					onClick={handleClick}
					className="d-flex align-items-center list-group-item text-primary font-weight-bold"
					href={`${allInventoryPath}?search=${encodeURIComponent(
						searchTerm
					)}`}
				>
					<span className="ddc-font-size-small">{viewLinkLabel}</span>
					<i
						className="ddc-icon ddc-icon-arrow-details ml-3"
						aria-hidden="true"
					/>
				</a>
				<h3 id="vehicle-cards-heading" className="sr-only">
					{labels.get('VEHICLE_SEARCH_RESULTS')}
				</h3>
				{vehicles.slice(0, 5).map((vehicle) => {
					const {
						path,
						images: [image1, image2],
						title,
						price,
						odometer,
						odometerUnit,
						condition
					} = vehicle;

					const titleString = Array.isArray(title)
						? title.join(' ')
						: title;

					const image =
						image2 && vehicleCardImage === 'secondary'
							? image2
							: image1;
					const capitalizedCondition = condition.toUpperCase();
					keyCount += 1;
					return (
						<VehicleCard
							href={path || null}
							imageUrl={image.url}
							imageAlt={titleString}
							key={keyCount}
							title={titleString}
							price={price}
							odometer={odometer}
							odometerUnit={odometerUnit}
							condition={capitalizedCondition}
							handleLinkClick={handleLinkClick}
						/>
					);
				})}
			</div>
		);
	}
	return null;
};

VehicleCards.propTypes = {
	vehicles: PropTypes.arrayOf(
		PropTypes.shape({
			path: PropTypes.string,
			title: PropTypes.arrayOf(PropTypes.string),
			images: PropTypes.arrayOf(PropTypes.shape({})),
			price: PropTypes.string,
			odometer: PropTypes.string,
			odometerUnit: PropTypes.string,
			condition: PropTypes.string
		})
	),
	searchTerm: PropTypes.string,
	handleLinkClick: PropTypes.func,
	inputWidth: PropTypes.number.isRequired
};

export default VehicleCards;
